module.exports = __webpack_public_path__ + "img/img_student2.000ece14.png";